export const customEventHeaders = [
  { label: "Custom event name", key: "name", width: 200 },
  { label: "Created by", key: "created_by", width: 200, view: true },
  { label: "Last updated", key: "updated_at", width: 200 },
  { label: "Status", key: "status", width: 200 },
];

export const authTypeOptions = [
  { value: "none", label: "None" },
  { value: "api_key", label: "API Key" },
  { value: "bearer", label: "Bearer Token" },
  { value: "meta_hmac", label: "Meta HMAC (SHA256)" },
  { value: "google_ads", label: "Google Ads" },
];
